export const Heading = {
  sizes: {
    'admin-display': {
      fontSize: { base: '4xl', sm: '4xl' },
      lineHeight: { base: '4xl', sm: '4xl' },
      fontWeight: 'extrabold',
    },
    'admin-h1': {
      fontSize: { base: '2xl', sm: '2xl' },
      lineHeight: { base: '2xl', sm: '2xl' },
      letterSpacing: 'wide',
      fontWeight: 'semibold',
    },
    'admin-h2': {
      fontSize: { base: 'xl', sm: 'xl' },
      lineHeight: { base: 'xl', sm: 'xl' },
      fontWeight: 'semibold',
    },
    'admin-h3': {
      fontSize: 'lg',
      lineHeight: 'xl',
      fontWeight: 'semibold',
    },
    'admin-h4': {
      fontSize: 'md',
      lineHeight: 'lg',
      fontWeight: 'semibold',
    },
  },
};
